<template>
  <div id="messagesPage"
       class="container-fluid has-action-bar has-footer mb-10">
    <ActionBar title="پیام ها"></ActionBar>
    <div v-if="contentLoaded && tickets.length > 0"
         class="row  mt-2 mx-1">
      <v-expansion-panels focusable>
        <v-expansion-panel
            v-for="(item,i) in tickets"
            :key="i">
          <v-expansion-panel-header>
            {{item.name }}
          </v-expansion-panel-header>
          <v-expansion-panel-content >
            <div class="row mt-1">
            <div v-for="tickets in item.messages"
                 :key="tickets.TicketID"
                 class="col-12  col-sm-6 col-md-4 col-lg-3">
              <div class="card-box-shadow rounded-lg p-2 cursor-pointer" @click="goToTicketDetail(tickets.TicketID)">
                <v-badge
                    :content="typeTicketStatus[tickets.TypeTicketStatus]"
                    color="primary"
                    inline>
                  <div class="font-weight-bold font16px ml-2">{{ tickets.Subject }}</div>
                </v-badge>
                <div class="font12px">
                  <span class="font-weight-bold font12px">دسته بندی:</span> {{ (tickets.TicketCategoryName) }}

                </div>
                <div class="text-left">
                  <i class="fal fa-calendar-alt primary-text"></i> {{ $convertDate(tickets.ModifiedDate) }}
                </div>
              </div>

            </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

    </div>
    <div v-if="contentLoaded && tickets.length === 0">
      <div class="row mx-2 mt-10 knowledge-base-body">
        <div class="col-12">
          <v-alert
              border="bottom"
              class="mt-4 text-center"
              color="forth"
              dark>
            پیامی وجود ندارد
          </v-alert>
        </div>
      </div>
    </div>
    <v-fab-transition>
      <v-btn
          id="memberShipFabBtn"
          color="primary"
          dark
          fab
          fixed
          large
          left
          @click="newTicketDialog = true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-dialog
        v-model="newTicketDialog"
        width="500">
      <v-card class="text-right pt-5">
        <v-card-text class="pb-0">
          دسته بندی:
          <v-autocomplete
              v-model="categoryId"
              :items="categoriesItems"
              class="input-border gray-bg-input"
              color="white"
              dense
              item-text="Text"
              item-value="Value"
              solo></v-autocomplete>
          موضوع پیام:
          <v-text-field
              v-model="subject"
              class="input-border gray-bg-input"
              dense
              solo
              type="text">
          </v-text-field>
          متن پیام:
          <v-textarea
              v-model="description"
              class="input-border gray-bg-input "
              dense
              solo
              type="text">
          </v-textarea>
          آپلود فایل:
          <div class="light-gray-bottom-border d-flex p-2">
            <v-file-input
                id="ImageFileUrl"
                class="input-border"
                dense
                hide-details
                name="ImageFileUrl"
                solo></v-file-input>
          </div>
        </v-card-text>

        <v-card-actions class=" py-3 justify-center">
          <v-btn class="w-50" color="primary" outlined rounded @click="newTicketDialog = !newTicketDialog">
            <span class="font12px">بستن</span>
          </v-btn>
          <v-btn
              :disabled="categoryId === null || description === null || subject === null"
              class="primary w-50" rounded @click="registerMessage">
            <span class="font12px">ثبت پیام</span>
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showResultDialog"
        persistent
        hide-overlay
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <FooterMenu :currentPage="'messages'"/>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "Messages",
  metaInfo: {
    title: 'مسیربرتر-پیام ها'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    tickets: [],
    contentLoaded: false,
    newTicketDialog: false,
    showLoaderDialog: false,
    showResultDialog: false,
    dialogResult: '',
    categoriesItems: [],
    categoryId: null,
    description: null,
    subject: null,
    typeTicketStatus: ['', 'تازه ثبت شده', 'در حال پیگیری', 'پاسخ داده شده', 'بسته_شده']
  }),
  mounted() {
    _this = this;

    this.getDefine()
    this.getList()
  },
  methods: {
    getDefine() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "TicketManagement/Define", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result);
            _this.categoriesItems = json.TicketCategories.filter(x => x.Disabled === false)
            _this.contentLoaded = true

          })
          .catch(error => console.log('error', error));
    },
    getList() {
      this.showLoaderDialog = true;
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "TicketManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false
            let json =JSON.parse(result)

            let listTickets = json.list
            let finalArray=[]
            let categories = listTickets.map(item => item.TicketCategoryID)
                .filter((value, index, self) => self.indexOf(value) === index)
            for (let i=0;i<categories.length;i++){
              let find = listTickets.filter(x=> x.TicketCategoryID === categories[i])
              let name = find[0].TicketCategoryName
              finalArray.push({id:categories[i],name:name,messages:find})
            }
            _this.tickets = finalArray;
            this.$scrollTop(0);
          })
          .catch(error => {
            _this.showLoaderDialog = false
            console.log('error', error)
          });
    },
    registerMessage() {
      this.newTicketDialog = false;
      this.showLoaderDialog = true;

      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      // myHeaders.append("Content-Type", "multipart/form-data");

      let formdata = new FormData();
      formdata.append("Description", _this.description);
      formdata.append("Subject", _this.subject);
      formdata.append("TicketCategoryID", _this.categoryId);
      formdata.append("ImageFileUrl", document.getElementById('ImageFileUrl').files[0]);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "TicketManagement/Define", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.showResultDialog = true;
            _this.dialogResult = result;
            _this.getList()
          })
          .catch(error => console.log('error', error));

    },
    goToTicketDetail(id) {

      this.$router.push({path: 'MessageDetail', query: {TicketID: id}})

    }
  }

}
</script>
